
$(document).ready(function() {
    $('#profile_page a.signin').click(function() {
        window.sign_in_view.sign_in();
    });

    $('#profile_page a.register').click(function() {
        window.sign_in_view.register();
    });
});



// WEBPACK FOOTER //
// ./assets/es6/profile/restricted.es6